// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"2a7e8a6d","198":"d7c5c136","213":"992f4f4c","455":"ff07e762","833":"88ba40e7"}[chunkId] + ".chunk.js";
};